import camelCase from 'lodash/camelCase';
import LegacyConstituentCategories from '@/constants/constituents/LegacyConstituentCategories';
import ConstituentIcons from '@/lib/configs/ConstituentIcons';
import { ConstituentType } from '@/lib/types/ConstituentPropType';
import type SearchConstituent from '@/types/api/SearchConstituent';

const filterConstituentCategoryIcons = (constituent: SearchConstituent) => {
  return ConstituentIcons.filter(({ value }) =>
    value === LegacyConstituentCategories.CATEGORY_CORPORATION ||
    value === LegacyConstituentCategories.CATEGORY_FOUNDATION ||
    value === LegacyConstituentCategories.CATEGORY_GOVERNMENT
      ? constituent.constituentType === ConstituentType.ORG &&
        constituent[camelCase(value) as keyof SearchConstituent]
      : constituent[camelCase(value) as keyof SearchConstituent],
  );
};

export default filterConstituentCategoryIcons;
